import React, { useRef, useState, useEffect } from 'react';
import {
  MB,
  MEDIUM_COMPONENT_SIZE,
  MIME_TYPES_MAP,
  REQUIRED_KEY,
  SMALL_COMPONENT_SIZE,
  EMPTY_FILE_SIZE,
} from '../../../utils/Constants';

export const useDraggableInputFile = (
  setValue,
  fileTypes,
  maxFileSize,
  inputSize,
  value,
  handleBlur
) => {
  const [showFileNameArea, setShowFileNameArea] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [fileData, setFileData] = useState({
    name: value?.name || '',
    size: value?.size || 0,
  });

  const inputFileRef = useRef(null);

  const errorMessages = {
    INVALID_FILE_SIZE: {
      [MEDIUM_COMPONENT_SIZE]:
        'El archivo supera el peso máximo. Por favor, volvé a intentarlo.',
      [SMALL_COMPONENT_SIZE]: (
        <>
          El archivo supera el peso máximo.
          <br />
          Por favor, volvé a intentarlo.
        </>
      ),
    },
    EMPTY_FILE: {
      [MEDIUM_COMPONENT_SIZE]: 'El archivo no tiene datos, volvé a intentarlo',
      [SMALL_COMPONENT_SIZE]: 'El archivo no tiene datos, volvé a intentarlo',
    },
    INVALID_FILE_TYPE: {
      [MEDIUM_COMPONENT_SIZE]:
        'Tipo de archivo no soportado. Por favor, volvé a intentarlo.',
      [SMALL_COMPONENT_SIZE]: (
        <>
          Tipo de archivo no soportado.
          <br />
          Por favor, volvé a intentarlo.
        </>
      ),
    },
  };

  const supportedTypes = fileTypes.map((type) => MIME_TYPES_MAP[type]);

  const convertMBToByte = (fileSize) => fileSize * MB;

  const handleFile = (file) => {
    setValue(file);
    setFileData({
      name: file.name,
      size: file.size,
    });
  };

  const showError = (file) => {
    setValue(file);
    setFileData({});
    setShowErrorMessage(true);
  };

  const deleteAttachedFile = () => {
    setValue(null);
    setFileData({});
    setShowErrorMessage(false);
    setErrorMessage(REQUIRED_KEY);
  };

  const validFileType = (file) => {
    if (supportedTypes.includes(file?.type)) {
      return true;
    } else {
      setErrorMessage(errorMessages.INVALID_FILE_TYPE[inputSize]);
      return false;
    }
  };

  const validFileSize = (file) => {
    if (file.size === convertMBToByte(EMPTY_FILE_SIZE)) {
      setErrorMessage(errorMessages.EMPTY_FILE[inputSize]);
      return false;
    }
    if (file.size <= convertMBToByte(maxFileSize)) {
      return true;
    } else {
      setErrorMessage(errorMessages.INVALID_FILE_SIZE[inputSize]);
      return false;
    }
  };

  const removeDragData = (ev) => {
    ev.dataTransfer.items?.clear();
    ev.dataTransfer.clearData();
  };

  const removeInputFileData = () => {
    inputFileRef.current.value = '';
  };

  const dragOverHandler = (ev) => {
    ev.preventDefault();
  };

  const relaunchHandlerBlur = (e) => {
    const newEvent = { ...e, target: inputFileRef.current };
    handleBlur && handleBlur(newEvent);
  };

  const dropHandler = (ev) => {
    ev.preventDefault();
    [...ev.dataTransfer.items].map((dataTransferItem) => {
      if (dataTransferItem.kind === 'file') {
        relaunchHandlerBlur(ev);
        const file = dataTransferItem.getAsFile();
        if (validFileType(file) && validFileSize(file)) {
          handleFile(file);
        } else {
          showError(file);
        }
      }
      return false;
    });
    removeDragData(ev);
  };

  const handleInputFileClick = (ev) => {
    ev.preventDefault();
    relaunchHandlerBlur(ev);
    const file = inputFileRef.current.files[0];
    if (validFileType(file) && validFileSize(file)) {
      handleFile(file);
    } else {
      showError(file);
    }
    removeInputFileData();
  };

  const handleDeleteClick = () => {
    deleteAttachedFile();
  };
  useEffect(() => {
    fileData?.name !== '' && parseFloat(fileData?.size) > 0
      ? setShowFileNameArea(true)
      : setShowFileNameArea(false);
  }, [fileData]);
  return [
    dragOverHandler,
    dropHandler,
    errorMessage,
    fileData,
    handleDeleteClick,
    handleInputFileClick,
    inputFileRef,
    showErrorMessage,
    showFileNameArea,
  ];
};
